import { useState, useEffect } from 'react';
import { useFetchOrganizationConfigQuery, useUpdateOrganizationConfigMutation, useCreateOrganizationConfigMutation } from '../../../../common/api/lmsApi';
import md5 from 'md5'


export const useMoodleConfig = (organizationId: string) => {
  const [isUpdate, setIsUpdate] = useState(false);
  const [config, setConfig] = useState({
    lmsUrl: '',
    refreshToken: '',
    proviewWsFunction: '',
    proviewName:'',
    isAutoSyncEnabled: false,
  });
  const { data, error, isLoading } = useFetchOrganizationConfigQuery(organizationId);
  const [updateOrganizationConfig] = useUpdateOrganizationConfigMutation();
  const [createOrganizationConfig] = useCreateOrganizationConfigMutation();

  useEffect(() => {
    if (data) {
      setIsUpdate(true);
      setConfig({
        proviewName:data?.name || '',
        lmsUrl: data?.lms_config?.moodle?.url || '',
        refreshToken: data?.lms_config?.moodle?.secrets?.token || '',
        proviewWsFunction:data?.lms_config?.moodle?.wsfunction || '',
        isAutoSyncEnabled: data?.is_auto_sync || false
      });
    }
  }, [data]);

  const handleUpdateConfiguration = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const data = {
      lms_config: {
        type: 'MOODLE',
        moodle: {
          secrets: {
            token: config.refreshToken,
          },
          url: config.lmsUrl,
          wsfunction:config.proviewWsFunction
        },
      },
      is_auto_sync: config.isAutoSyncEnabled,
      proview_organization_id: organizationId,
      name: config.proviewName,
    };
    if (isUpdate) {
      updateOrganizationConfig({ organizationId, data })
        .then(() => alert('Configuration updated successfully.'))
        .catch((error) => console.error('Error updating configuration:', error));
    } else {
      createOrganizationConfig(data)
        .then(() => alert('Configuration created successfully.'))
        .catch((error) => console.error('Error creating configuration:', error));
    }
  };

  return {
    config,
    setConfig,
    isUpdate,
    isLoading,
    handleUpdateConfiguration,
  };
};
